































































import Vue from "vue";
import { Trans } from "@/shared/scripts/helpers/translation/translation";

export default Vue.extend({
    props: {
        bannerLocation: {
            type: String,
            required: false,
            default: "landing"
        },
    },

    computed: {
        url: function (): string {
            const valuationQueryParams =
                `utm_source=immoweb&utm_medium=referral&utm_campaign=self-promo-valuation082022-entrypoints&utm_content=encoding-funnel-${this.bannerLocation}-page`;
            switch (Trans.currentLocale) {
            case "fr":
                return `${process.env.VUE_APP_MANDATE_FUNNEL_FR_URL}?${valuationQueryParams}`;
            case "nl":
                return `${process.env.VUE_APP_MANDATE_FUNNEL_NL_URL}?${valuationQueryParams}`;
            default:
                return `${process.env.VUE_APP_MANDATE_FUNNEL_EN_URL}?${valuationQueryParams}`;
            }
        },
    }
});
